import React from 'react'
import { ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Switch,
  Typography,
  Link,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'tss-react/mui'

type Props = {
  title: string
  description: string
  value?: boolean
  onChange?: any
  isRequired?: boolean
}

export function CookieBannerAccordion(props: Props) {
  const { title, description, value, onChange, isRequired } = props
  const { classes } = useStyles()
  const { t } = useTranslation()

  return (
    <Accordion
      classes={{
        root: classes.root,
        expanded: classes.expanded,
      }}
    >
      <Box className={classes.wrapper}>
        <AccordionSummary
          classes={{
            root: classes.accSummary,
            content: classes.content,
            expandIconWrapper: classes.expandIconWrapper,
            expanded: classes.expanded,
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography variant="h3">{title}</Typography>
        </AccordionSummary>
        {isRequired ? (
          <Switch checked disabled />
        ) : (
          <Switch checked={value} onChange={onChange} />
        )}
      </Box>
      <AccordionDetails className={classes.accDetails}>
        {description}
      </AccordionDetails>
      <Link href="/cookies" target="_blank">
        <Typography className={classes.link}>
          {t('cookiesBanner.findMore')}
        </Typography>
      </Link>
    </Accordion>
  )
}

const useStyles = makeStyles<void, 'expanded'>()((theme, _, classes) => ({
  expanded: {},
  root: {
    backgroundColor: theme.palette.common.white,
    padding: '1.25rem',
    [`&.${classes.expanded}`]: {
      margin: 0,
    },
    '&:before': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0.75rem',
    },
  },
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  accSummary: {
    flex: 1,
    flexDirection: 'row-reverse',
    gap: '1rem',
    paddingInline: 0,
    minHeight: 0,
    '&:focus': {
      outline: 0,
    },
    [`&.${classes.expanded}`]: {
      minHeight: 0,
    },
  },
  content: {
    margin: 0,
    [`&.${classes.expanded}`]: {
      margin: 0,
    },
  },
  expandIconWrapper: {
    color: theme.palette.text.primary,
    padding: 0,
  },
  accDetails: {
    padding: '1rem 0 0 0',
  },
  accActions: {
    padding: '1.75rem',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      padding: '1.125rem',
    },
  },
  link: {
    textDecoration: 'underline',
    fontWeight: 600,
    padding: 10,
    paddingLeft: 0,
  },
}))
